import moment from 'moment'
import { CRM_DATE_FORMAT } from '../constants'
import * as R from 'ramda'
import { EXTERNAL_GROUP, ORDINARY_GROUP } from 'commons/groupLogic'

export default function (
  subscriber,
  countryList,
  statePhysicalList,
  stateMailingList,
) {
  subscriber.crmInfo = subscriber.crmInfo || {}

  function getTags() {
    return subscriber.tags.map((data) => data.id)
  }

  function getFullPhoneNumber() {
    return subscriber.crmInfo.countryCode && subscriber.crmInfo.phoneNumber
      ? `${subscriber.crmInfo.countryCode}${subscriber.crmInfo.phoneNumber}`
      : false
  }

  function getautomatedCallFullPhoneNumber() {
    return subscriber.crmInfo.automatedCallCountryCode &&
      subscriber.crmInfo.automatedCallPhoneNumber
      ? `${subscriber.crmInfo.automatedCallCountryCode}${subscriber.crmInfo.automatedCallPhoneNumber}`
      : ''
  }

  function getCrmField(prop, defaultValue = '') {
    return subscriber.crmInfo[prop] || defaultValue
  }

  function getCountryField(prop) {
    const objectCountry = {
      id: null,
      name: '',
      code: '',
      regionType: '',
    }

    const country = subscriber.crmInfo[prop]
      ? R.find((item) => {
          return item.id === subscriber.crmInfo[prop]
        }, countryList)
      : objectCountry

    return !R.isNil(country) ? country : objectCountry
  }

  function getStateField(prop, stateLists) {
    const objectState = {
      id: null,
      name: '',
      countryId: null,
    }

    if (R.isEmpty(stateLists)) return objectState
    const state = subscriber.crmInfo[prop]
      ? R.find((item) => {
          return item.id === subscriber.crmInfo[prop]
        }, stateLists)
      : objectState

    return !R.isNil(state) ? state : objectState
  }

  function getField(prop, defaultValue = '') {
    return subscriber[prop] || defaultValue
  }

  function getGroups() {
    let groupList = {}
    let count = 0
    subscriber.tags &&
      subscriber.tags.forEach((item) => {
        const groupType = item['group']['type']
        if ([ORDINARY_GROUP, EXTERNAL_GROUP].includes(groupType)) {
          if (!groupList[item['group']['name']]) {
            groupList[item['group']['name']] = []
          }
          groupList[item['group']['name']].push(item['name'])
          count++
        }
      })

    return { groupList, count }
  }

  const crmData = {
    originalFirstName: getField('firstName'),
    originalLastName: getField('lastName'),
    topics: getField('topics'),
    originalCareCheckId: getField('carecheckId'),
    groups: getGroups(),
    tags: getTags(),
    uniqueId: subscriber.uniqueId,
    birthday:
      subscriber.birthday &&
      moment(subscriber.birthday).format(CRM_DATE_FORMAT),
    crmBirthday:
      subscriber.crmInfo.birthday &&
      moment(subscriber.crmInfo.birthday).format(CRM_DATE_FORMAT),
    avatar: getCrmField('avatar'),
    firstName: getCrmField('firstName'),
    lastName: getCrmField('lastName'),
    email: getCrmField('email'),
    phone: getCrmField('phone'),
    formalTitle: getCrmField('formalTitle'),
    prefix: getCrmField('prefix'),
    suffix: getCrmField('suffix'),
    middleName: getCrmField('middleName'),
    phoneticFirstName: getCrmField('phoneticFirstName'),
    phoneticLastName: getCrmField('phoneticLastName'),
    phoneticMiddleName: getCrmField('phoneticMiddleName'),
    nickname: getCrmField('nickname'),
    secondaryEmail: getCrmField('secondaryEmail'),
    companyName: getCrmField('companyName'),
    jobTitle: getCrmField('jobTitle'),
    jobDepartment: getCrmField('jobDepartment'),
    facebookProfile: getCrmField('facebookProfile'),
    twitterProfile: getCrmField('twitterProfile'),
    linkedinProfile: getCrmField('linkedinProfile'),
    lineProfile: getCrmField('lineProfile'),
    contactable: getCrmField('contactable', 0),
    gender: getCrmField('gender'),
    crmLanguageId: getCrmField('crmLanguageId'),
    hasBadContact: getField('hasBadContact'),
    preferLanguage: subscriber?.language?.id ?? 1,

    physicalCountryName: getCrmField('physicalCountryName'),
    physicalCountryId: getCrmField('physicalCountryId'),
    physicalCountry: getCountryField('physicalCountry'),
    physicalState: getStateField('physicalState', statePhysicalList),
    physicalStreetAddress1: getCrmField('physicalStreetAddress1'),
    physicalStreetAddress2: getCrmField('physicalStreetAddress2'),
    physicalCityName: getCrmField('physicalCityName'),
    physicalPostalCode: getCrmField('physicalPostalCode'),

    mailingCountryName: getCrmField('mailingCountryName'),
    mailingCountryId: getCrmField('mailingCountryId'),
    mailingCountry: getCountryField('mailingCountry'),
    mailingState: getStateField('mailingState', stateMailingList),
    mailingStreetAddress1: getCrmField('mailingStreetAddress1'),
    mailingStreetAddress2: getCrmField('mailingStreetAddress2'),
    mailingCityName: getCrmField('mailingCityName'),
    mailingPostalCode: getCrmField('mailingPostalCode'),

    countryCode: getCrmField('countryCode'),
    phoneNumber: getCrmField('phoneNumber'),
    fullPhoneNumber: getFullPhoneNumber(),

    automatedCallCountryCode: getCrmField('automatedCallCountryCode'),
    automatedCallPhoneNumber: getCrmField('automatedCallPhoneNumber'),
    automatedCallFullPhoneNumber: getautomatedCallFullPhoneNumber(),

    mobileCountryCode: getCrmField('mobileCountryCode'),
    mobilePhoneNumber: getCrmField('mobilePhoneNumber'),
    fullOtherMobileNumber: getFullOtherMobileNumber(),

    otherCountryCode: getCrmField('otherCountryCode'),
    otherPhoneNumber: getCrmField('otherPhoneNumber'),
    fullOtherPhoneNumber: getFullOtherPhoneNumber(),

    officeCountryCode: getCrmField('officeCountryCode'),
    officePhoneNumber: getCrmField('officePhoneNumber'),
    fullOfficePhoneNumber: getFullOfficePhoneNumber(),

    homeCountryCode: getCrmField('homeCountryCode'),
    homePhoneNumber: getCrmField('homePhoneNumber'),
    fullHomePhoneNumber: getFullHomePhoneNumber(),

    faxCountryCode: getCrmField('faxCountryCode'),
    faxPhoneNumber: getCrmField('faxPhoneNumber'),
    fullFaxNumber: getFullFaxNumber(),
    preferedContact: getField('receiveMethods'),
    placeOfBirth: getCrmField('placeOfBirth'),
    nationality: getCrmField('nationality'),
    passportExpiresAt:
      subscriber.crmInfo.passportExpiresAt &&
      moment(subscriber.crmInfo.passportExpiresAt).format(CRM_DATE_FORMAT),
    passportId: getCrmField('passportId'),
    passportCountryCode: getCrmField('passportCountryCode'),

    isTranslated: getCrmField('isTranslated', false),
  }

  function getFullOtherMobileNumber() {
    return subscriber.crmInfo.mobileCountryCode &&
      subscriber.crmInfo.mobilePhoneNumber
      ? `${subscriber.crmInfo.mobileCountryCode}${subscriber.crmInfo.mobilePhoneNumber}`
      : false
  }

  function getFullOtherPhoneNumber() {
    return subscriber.crmInfo.otherCountryCode &&
      subscriber.crmInfo.otherPhoneNumber
      ? `${subscriber.crmInfo.otherCountryCode}${subscriber.crmInfo.otherPhoneNumber}`
      : false
  }

  function getFullOfficePhoneNumber() {
    return subscriber.crmInfo.officeCountryCode &&
      subscriber.crmInfo.officePhoneNumber
      ? `${subscriber.crmInfo.officeCountryCode}${subscriber.crmInfo.officePhoneNumber}`
      : false
  }

  function getFullHomePhoneNumber() {
    return subscriber.crmInfo.homeCountryCode &&
      subscriber.crmInfo.homePhoneNumber
      ? `${subscriber.crmInfo.homeCountryCode}${subscriber.crmInfo.homePhoneNumber}`
      : false
  }

  function getFullFaxNumber() {
    return subscriber.crmInfo.faxCountryCode &&
      subscriber.crmInfo.faxPhoneNumber
      ? `${subscriber.crmInfo.faxCountryCode}${subscriber.crmInfo.faxPhoneNumber}`
      : false
  }

  crmData.phoneticFullName =
    `${crmData.phoneticFirstName} ${crmData.phoneticMiddleName} ${crmData.phoneticLastName} `.trim()
  crmData.fullName =
    `${crmData.formalTitle} ${crmData.prefix} ${crmData.firstName} ${crmData.middleName} ${crmData.lastName} ${crmData.suffix}`.trim()
  crmData.contactableText = crmData.contactable ? 'Yes' : 'No'
  return crmData
}
